"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Company {
}
exports.Company = Company;
//# sourceMappingURL=Company.js.map